
import React, { useEffect, ReactNode } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";
import { Theme } from "@mui/material/styles";

import MDBox from "components/MDBox";

//  context
import { useMaterialUIController, setLayout } from "context";

function DashboardLayout({ children }: { children: ReactNode }): React.JSX.Element {
  const [controller, dispatch] = useMaterialUIController();
  const { pathname } = useLocation();
  const { darkMode } = controller;
  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <MDBox
      className={darkMode && "dark-theme"}
      sx={({ breakpoints, transitions }: Theme) => ({
        // Full viewport height — locks the page shell so the document itself does not scroll.
        height: "100dvh",
        maxHeight: "100dvh",
        // Flex column so children can fill remaining space with flex: 1.
        display: "flex",
        flexDirection: "column",
        // Prevent the layout shell from scrolling; inner regions own overflow.
        overflow: "hidden",
        [breakpoints.up("xl")]: {
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
      })}
    >
      {children}
    </MDBox>
  );
}

export default DashboardLayout;
